import { Pipe, PipeTransform } from '@angular/core';
import { IPenalty } from "libraries/service/resources/hotel/IResourceHotel";
import { CancellationPipesService } from "./cancellation-pipes.service";

@Pipe({
 name: 'isSameAsDateLastCancellationWithoutPenalty'
})

export class IsSameAsDateLastCancellationWithoutPenaltyPipe implements PipeTransform {

    constructor(
        private readonly cancellationPipesService: CancellationPipesService
    ) {
    }
    public transform(penalty: IPenalty, dateLastCancellationWithoutPenalty: string): boolean {
        return penalty &&
            penalty.validity &&
            penalty.validity.end === dateLastCancellationWithoutPenalty &&
            this.cancellationPipesService.isFreePenalty(penalty);
    }
}